import React from "react";

import { type DesignElementManagerType } from "@hooks/use-design-element-manager";

import { MetricCategory } from "./metric-categorizer";

export const getCategoryIcon = (
  designElementManager: DesignElementManagerType,
  category: MetricCategory,
) => {
  switch (category) {
    case MetricCategory.SNAPCHAT:
      return <>{designElementManager.snapchat.getComponent()}</>;
    case MetricCategory.FACEBOOK:
      return <>{designElementManager.facebook.getComponent()}</>;
    case MetricCategory.GOOGLE:
      return <>{designElementManager.google.getComponent()}</>;
    case MetricCategory.TIK_TOK:
      return <>{designElementManager.tikTok.getComponent()}</>;
    case MetricCategory.YOU_TUBE:
      return <>{designElementManager.youTube.getComponent()}</>;
    case MetricCategory.SUBSCRIPTION:
    case MetricCategory.LTV:
    case MetricCategory.PLATFORM_BENCHMARKS:
    default:
      return <>{designElementManager.northbeam.getComponent()}</>;
  }
};
